import {
  ClipSceneIcon,
  ClipSceneSubmenu,
} from "@/components/ui/clip-scene-tool-ui";
import { ToolName } from "@/store/ui/ui-slice";
import { FaroTooltip, ToolButton } from "@faro-lotv/flat-ui";
import { Popper } from "@mui/material";
import { useRef, type JSX } from "react";

interface ClipSceneToolButtonProps {
  /** The currently active tool */
  activeTool?: ToolName;

  /** Callback when the user requests to toggle a tool*/
  onToggleTool(toggleTool: ToolName): void;
}

/** @returns the clipping box tool button of the data-preparation tool, to be placed in a ToolGroup */
export function ClipSceneToolButton({
  activeTool,
  onToggleTool,
}: ClipSceneToolButtonProps): JSX.Element {
  const clipSceneToolButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <FaroTooltip title="Clipping box" placement="left">
        <ToolButton
          aria-label="clipping box"
          ref={clipSceneToolButtonRef}
          onClick={() => onToggleTool(ToolName.clipScene)}
          selected={activeTool === ToolName.clipScene}
        >
          <ClipSceneIcon />
        </ToolButton>
      </FaroTooltip>

      <Popper
        open={activeTool === ToolName.clipScene}
        anchorEl={clipSceneToolButtonRef.current}
        placement="left"
        sx={{ p: 1 }}
      >
        <ClipSceneSubmenu />
      </Popper>
    </>
  );
}
